import type { ReactNode } from "react";
import React from "react";
import { Col, Row } from "react-bootstrap";
import "./ProgressBar.scss";

export interface ProgressBarProps {
	stepNumber: number;
	numberOfCells: number;
}

export class ProgressBar extends React.Component<ProgressBarProps> {
	private renderProgressBar(): ReactNode {
		const { stepNumber, numberOfCells } = this.props;
		const bars = [];

		for (let i = 0; i < numberOfCells; i++) {
			bars.push(
				<Col key={i} className="px-1">
					<div
						className={`progress-bar-item rounded-pill w-100 ${i < stepNumber ? "bg-primary" : "bg-gray"}`}
					/>
				</Col>,
			);
		}

		return <Row className="d-xl-none bg-white w-100 mx-0 mb-3">{bars}</Row>;
	}

	public render(): ReactNode {
		return this.renderProgressBar();
	}
}
